var _path, _g, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_587_9637",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H20.6966V20.6689H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_587_9637)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.64251 1.5C2.73851 1.5 1.49951 2.976 1.49951 6.433V14.232C1.49951 17.416 3.25751 19.169 6.44951 19.169H14.2315C17.4155 19.169 19.1685 17.416 19.1685 14.232V14.229L19.1965 9.264C19.1965 5.865 18.0305 4.54 15.0355 4.54H12.2055C11.2565 4.539 10.3505 4.086 9.78051 3.328L8.86751 2.114C8.58051 1.729 8.12151 1.501 7.64151 1.5H5.64251ZM14.2315 20.669H6.44951C2.47151 20.669 -0.000488281 18.202 -0.000488281 14.232V6.433C-0.000488281 2.164 1.89851 0 5.64251 0H7.64251C8.59351 0.001 9.49951 0.455 10.0675 1.214L10.9785 2.426C11.2675 2.81 11.7265 3.039 12.2065 3.04H15.0355C18.8975 3.04 20.6965 5.019 20.6965 9.268L20.6685 14.235C20.6675 18.203 18.2015 20.669 14.2315 20.669V20.669Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.716 13.7128H5.98096C5.56696 13.7128 5.23096 13.3768 5.23096 12.9628C5.23096 12.5488 5.56696 12.2128 5.98096 12.2128H14.716C15.13 12.2128 15.466 12.5488 15.466 12.9628C15.466 13.3768 15.13 13.7128 14.716 13.7128",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopic);
export default __webpack_public_path__ + "static/media/topic.fe5009ed.svg";
export { ForwardRef as ReactComponent };